module.exports = __webpack_public_path__ + "assets/img/e9c688aa6c80ad1849bea1783ebf390a.png";